import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Table/table';
import stylesTreeView from '@patternfly/react-styles/css/components/Table/table-tree-view';
import { Button, Checkbox } from '@patternfly/react-core';
import AngleDownIcon from '@patternfly/react-icons/dist/esm/icons/angle-down-icon';
import EllipsisHIcon from '@patternfly/react-icons/dist/esm/icons/ellipsis-h-icon';
export var treeRow = function treeRow(onCollapse, onCheckChange, onToggleRowDetails) {
  return function (value, _ref) {
    var rowIndex = _ref.rowIndex,
        rowData = _ref.rowData;
    var _rowData$props = rowData.props,
        isExpanded = _rowData$props.isExpanded,
        isDetailsExpanded = _rowData$props.isDetailsExpanded,
        level = _rowData$props['aria-level'],
        setsize = _rowData$props['aria-setsize'],
        toggleAriaLabel = _rowData$props.toggleAriaLabel,
        checkAriaLabel = _rowData$props.checkAriaLabel,
        showDetailsAriaLabel = _rowData$props.showDetailsAriaLabel,
        isChecked = _rowData$props.isChecked,
        checkboxId = _rowData$props.checkboxId,
        icon = _rowData$props.icon;
    var content = value.title || value;
    var text = React.createElement("div", {
      className: css(stylesTreeView.tableTreeViewText),
      key: "tree-view-text"
    }, icon && React.createElement("span", {
      className: css(stylesTreeView.tableTreeViewIcon),
      key: "tree-view-text-icon"
    }, icon), React.createElement("span", {
      className: "pf-c-table__text",
      key: "table-text"
    }, content));

    var onChange = function onChange(isChecked, event) {
      onCheckChange(event, isChecked, rowIndex, content, rowData);
    };

    return {
      component: 'th',
      className: 'pf-c-table__tree-view-title-cell',
      children: level !== undefined ? React.createElement("div", {
        className: css(stylesTreeView.tableTreeViewMain)
      }, setsize > 0 && React.createElement("span", {
        className: css(stylesTreeView.tableToggle),
        key: "table-toggle"
      }, React.createElement(Button, {
        variant: "plain",
        onClick: function onClick(event) {
          return onCollapse && onCollapse(event, rowIndex, content, rowData);
        },
        className: css(isExpanded && styles.modifiers.expanded),
        "aria-expanded": isExpanded,
        "aria-label": toggleAriaLabel || "".concat(isExpanded ? 'Collapse' : 'Expand', " row ").concat(rowIndex)
      }, React.createElement("div", {
        className: css(stylesTreeView.tableToggleIcon)
      }, React.createElement(AngleDownIcon, {
        "aria-hidden": "true"
      })))), !!onCheckChange && React.createElement("span", {
        className: css(stylesTreeView.tableCheck),
        key: "table-check"
      }, React.createElement("label", {
        htmlFor: checkboxId || "checkbox_".concat(rowIndex)
      }, React.createElement(Checkbox, {
        id: checkboxId || "checkbox_".concat(rowIndex),
        "aria-label": checkAriaLabel || "Row ".concat(rowIndex, " checkbox"),
        isChecked: isChecked,
        onChange: onChange
      }))), text, !!onToggleRowDetails && React.createElement("span", {
        className: css(stylesTreeView.tableTreeViewDetailsToggle),
        key: "view-details-toggle"
      }, React.createElement(Button, {
        variant: "plain",
        "aria-expanded": isDetailsExpanded,
        "aria-label": showDetailsAriaLabel || 'Show row details',
        onClick: function onClick(event) {
          return onToggleRowDetails && onToggleRowDetails(event, rowIndex, content, rowData);
        }
      }, React.createElement("span", {
        className: "pf-c-table__details-toggle-icon"
      }, React.createElement(EllipsisHIcon, {
        "aria-hidden": true
      }))))) : text
    };
  };
};